import type { SVGProps } from 'react';

export const CheckmarkCircleOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M3.33308 11.9999C3.33308 7.2134 7.21327 3.33322 11.9997 3.33322C16.7862 3.33322 20.6664 7.2134 20.6664 11.9999C20.6664 16.7863 16.7862 20.6665 11.9997 20.6665C7.21327 20.6665 3.33308 16.7863 3.33308 11.9999ZM11.9997 1.33322C6.1087 1.33322 1.33308 6.10884 1.33308 11.9999C1.33308 17.8909 6.1087 22.6665 11.9997 22.6665C17.8907 22.6665 22.6664 17.8909 22.6664 11.9999C22.6664 6.10884 17.8907 1.33322 11.9997 1.33322ZM17.1243 8.94465C17.462 8.50764 17.3815 7.87961 16.9445 7.54192C16.5075 7.20423 15.8795 7.28474 15.5418 7.72176L10.6079 14.1067L8.40969 11.6642C8.04024 11.2537 7.40795 11.2204 6.99744 11.5899C6.58693 11.9594 6.55365 12.5916 6.92311 13.0022L9.9231 16.3355C10.1215 16.5559 10.4075 16.6769 10.7038 16.6658C11.0002 16.6547 11.2763 16.5126 11.4577 16.278L17.1243 8.94465Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
